import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
    import { useSystemStatsQueryV1 } from '@Organizations/OrganizationUnits/Domain/queries-vue-composables'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'SystemStatsPage',
  setup(__props) {

    const { modelSystemStatsQueryV1, runSystemStatsQueryV1 } = useSystemStatsQueryV1()

    onMounted(() => runSystemStatsQueryV1())

return { __sfc: true,modelSystemStatsQueryV1, runSystemStatsQueryV1 }
}

})